@if (editMode) {
  <div>
    <label class="checkbox">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <input
          type="checkbox"
          [value]="'asLink'"
          [checked]="displayAsLink"
          (change)="setDisplayAsLink($event)"
          class="mr-3 checkbox-size" />
        <div class="checkbox-text">{{ 'COMMUNICATIONS.CONFIRMATION-AS-LINK' | translate }}</div>
      </div>
    </label>
  </div>
}

@if (!editMode) {
  <div>
    <!-- show link response view -->
    @if (displayAsLink) {
      <div>
        <div class="confirmation-text">
          {{ confirmationText }}
        </div>
        <div class="confirmation-text">
          <a>{{ 'COMMUNICATIONS.MESSAGE-REPLY-HERE' | translate }}</a>
        </div>
      </div>
    }
    <!-- show Microsoft Teams response view -->
    @if (!displayAsLink && template.channelUId === ChannelUIds.MicrosoftTeamsChannelUId) {
      <div
        class="ms-teams-response-container">
        <div class="ms-teams-confirmation-text">{{ confirmationText }}</div>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
            <div>
              @if (confirmationButton?.type === ConfirmationType.Positive) {
                <div>
                  <a
                    data-confirmation-positive
                    class="ms-teams-button yes-button">
                    {{ confirmationButton.text }}
                  </a>
                </div>
              }
              @if (confirmationButton?.type !== ConfirmationType.Positive) {
                <div
                  data-confirmation-negative
                  >
                  <a
                    data-confirmation-negative
                    class="ms-teams-button no-button">
                    {{ confirmationButton.text }}
                  </a>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    <!-- show default response view -->
    @if (!displayAsLink && template.channelUId !== ChannelUIds.MicrosoftTeamsChannelUId) {
      <div>
        <div class="confirmation-text">{{ confirmationText }}</div>
        <div class="confirmation-buttons" [ngClass]="{'block-mode': isEmailChannel}">
          @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
            <div>
              @if (confirmationButton?.type === ConfirmationType.Positive) {
                <div>
                  <a
                    data-confirmation-positive
                    class="confirmation-button yes-button" [ngClass]="{'block-mode': isEmailChannel}">
                    {{ confirmationButton.text }}
                  </a>
                </div>
              }
              @if (confirmationButton?.type !== ConfirmationType.Positive) {
                <div
                  data-confirmation-negative
                  >
                  <a
                    data-confirmation-negative
                    class="confirmation-button no-button" [ngClass]="{'block-mode': isEmailChannel}">
                    {{ confirmationButton.text }}
                  </a>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
